"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BellSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M12.55 26a4 4 0 00-.05.5 3.5 3.5 0 007 0 4 4 0 00-.05-.5z"/><path d="M24.36 12.54A8.53 8.53 0 0017 4.07V3a1 1 0 00-2 0v1.06a8.29 8.29 0 00-7.37 8.19c0 8.23-4.64 6.47-4.64 11v.92A1.84 1.84 0 004.86 26h22.28A1.84 1.84 0 0029 24.17v-.92c0-4.48-4.53-2.81-4.64-10.71z"/>';
var BellSVG = function BellSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.BellSVG = BellSVG;
BellSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(BellSVG);
exports.default = _default;